import api from "./core";
import SessionService from "./session";

const basePath = "api/portal/Chats";
const baseUrl =
  process.env.VUE_APP_IS_STANDALONE === "false"
    ? "/"
    : process.env.VUE_APP_BASE_URL;

export default {
  create(data) {
    return api.put(`${basePath}`, data, {
      "Hide-Loading": true
    });
  },
  find(portalUserId) {
    return api.get(`${basePath}/FindRoom/${portalUserId}`, {
      "Hide-Loading": true
    });
  },
  createMsg(data) {
    const {
      SenderType,
      PatientId,
      SenderUserId,
      PortalUserId,
      DateTime,
      Message,
      Files,
      FilesData,
      Relationship
    } = data;
    var formData = new FormData();
    formData.append("SenderType", SenderType);
    formData.append("PatientId", PatientId);
    if (SenderUserId) formData.append("SenderUserId", SenderUserId);
    formData.append("PortalUserId", PortalUserId);
    formData.append("DateTime", DateTime);
    formData.append("Message", Message);
    formData.append("Relationship", Relationship);
    if (Files) {
      for (let index = 0; index < Files.length; index++) {
        const File = Files[index];
        formData.append("Files", File);
      }
      formData.append("FilesData", FilesData);
    }

    const config = {
      headers: {
        "Hide-Loading": true,
        "content-type": "multipart/form-data"
      }
    };
    return api.put(`${basePath}/CreateMsg`, formData, config);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`, {
      "Hide-Loading": true
    });
  },
  findById(id, patienId) {
    return api.get(`${basePath}/FindMsg/${id}/${patienId}`, {
      "Hide-Loading": true
    });
  },
  downloadUrl(id) {
    return `${baseUrl}${basePath}/Download/${
      SessionService.session().token
    }/${id}`;
  },
  getCaseLoad(id) {
    return api.get(`${basePath}/GetCaseLoad/${id}`, {
      "Hide-Loading": true
    });
  },
  sendToMainApp(data, signalrAppUrl) {
    return fetch(
      `${signalrAppUrl}/api/signalr/chat/SendNewMessageSignalToMainApp/${data.tenantName}/`,
      {
        body: JSON.stringify(data.receivers),
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${SessionService.session().token}`
        }
      }
    );
  },
  getReceivers() {
    return api.get(`${basePath}/GetReceivers`, {
      "Hide-Loading": true
    });
  }
};
